<template>
    <div class="overall-section" data-aos="fade-up" data-aos-once="true">
        <v-container>
            <v-card
            class="mx-auto"
            outlined
            color="#000000"
            style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title style="text-align:center;">Overall</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        color="secondary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openColSettingsModal"
                        v-if="showRequiredActions()"
                    >
                        <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
                    </v-btn>
                    <!-- <v-menu
                        :close-on-content-click="false"
                        bottom
                        left
                        v-if="showRequiredActions()"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                color="secondary"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(field, index) in showHideFields" :key="index">
                                <v-checkbox
                                v-model="campaign.performanceAnalysisStatus[field.name]"
                                :label="field.label"
                                color="secondary"
                                :true-value="true"
                                :false-value="false"
                                hide-details
                                @change="updatePerformanceAnalysisStatus"
                                ></v-checkbox>
                            </v-list-item>
                        </v-list>
                    </v-menu> -->
                </v-app-bar>
                <v-card-text class="overall-content">
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="12" md="12" lg="12" align="left">
                            <v-card
                            class="mx-auto"
                            max-width="344"
                            outlined
                            color="#000000"
                            >
                            <v-card-text>
                                <div style="text-align:center;color:#3F3FFF;font-size:40px;padding-bottom:10px;">
                                    Total Deliverables
                                </div>
                                <div style="text-align:center;color:#3F3FFF;font-size:28px;width:100%;line-height:50px;" v-if="displayFields('totalContents')">
                                    {{campaignKPI.minContent | thousandSeprator}} to {{campaignKPI.maxContent | thousandSeprator}} Contents
                                </div>
                                <div style="text-align:center;color:#3F3FFF;font-size:28px;width:100%;line-height:50px;" v-if="displayFields('totalOutreach')">
                                    {{campaignKPI.outreach | thousandSeprator}} Audience Size
                                </div>
                            </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="12" md="12" lg="12" align="left">
                            <v-card
                                class="mx-left"
                                max-width="344"
                                outlined
                                color="#000000"
                            >
                                <v-card-text>
                                    <div style="text-align:left;color:#3F3FFF;font-size:30px;">
                                        Achieved
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('contents')">
                            <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                                color="#000000"
                            >
                            <v-card-text>
                                <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                    {{summary.contents | thousandSeprator}}
                                </div>
                                <div style="text-align:center;color:#3F3FFF;font-size:30px;">
                                    Contents
                                </div>
                            </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('outreachImpressions')">
                            <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                                color="#000000"
                            >
                            <v-card-text>
                                <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                    {{summary.outreachImpressions | thousandSeprator}}
                                </div>
                                <div style="text-align:center;color:#3F3FFF;font-size:30px;">
                                    Audience Size + Impressions
                                </div>
                            </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('outreach')">
                            <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                                color="#000000"
                            >
                            <v-card-text>
                                <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                    {{summary.outreach | thousandSeprator}}
                                </div>
                                <div style="text-align:center;color:#3F3FFF;font-size:30px;">
                                    Audience Size
                                </div>
                            </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('interactions')">
                            <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                                color="#000000"
                            >
                            <v-card-text>
                                <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                    {{summary.engagement | thousandSeprator}}
                                </div>
                                <div style="text-align:center;color:#3F3FFF;font-size:30px;">
                                    Interactions
                                </div>
                            </v-card-text>
                            </v-card>
                        </v-col>
                        <!-- <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('totalEngRate')">
                            <v-card
                                class="mx-auto"
                                max-width="344"
                                outlined
                                color="#000000"
                            >
                            <v-card-text>
                                <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                    {{totalEngagementRate.toFixed(2)}} %
                                </div>
                                <div class="engRate-text">
                                    Total Engagement Rate
                                </div>
                            </v-card-text>
                            </v-card>
                        </v-col> -->
                    </v-row>
                    <div class="mt-2 pt-2" style="border-top:1px solid #212121">
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('postEngRate')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{postEngRate}} %
                                        </div>
                                        <div class="engRate-text">
                                            Post Engagement Rate by Interactions
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('reelEngRate')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{reelEngRate}} %
                                        </div>
                                        <div class="engRate-text">
                                            Reel Engagement Rate by Interactions
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('tiktokEngRate')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{tiktokEngRate}} %
                                        </div>
                                        <div class="engRate-text">
                                            TikTok Engagement Rate by Interactions
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('youtubeEngRate')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{youtubeEngRate}} %
                                        </div>
                                        <div class="engRate-text">
                                            Youtube Engagement Rate by Interactions
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- Start eng rate by views -->
                    <div class="mt-2 pt-2" style="border-top:1px solid #212121">
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('postEngRateView')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{postEngRateView}} %
                                        </div>
                                        <div class="engRate-text">
                                            Post Engagement Rate by Views
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('reelEngRateView')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{reelEngRateView}} %
                                        </div>
                                        <div class="engRate-text">
                                            Reel Engagement Rate by Views
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('tiktokEngRateView')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{tiktokEngRateView}} %
                                        </div>
                                        <div class="engRate-text">
                                            TikTok Engagement Rate by Views
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" align="center" v-if="displayFields('youtubeEngRateView')">
                                <v-card
                                    class="mx-left"
                                    max-width="344"
                                    outlined
                                    color="#000000"
                                >
                                    <v-card-text>
                                        <div style="text-align:center;color:#3F3FFF;font-size:48px;width:100%;line-height:50px;">
                                            {{youtubeEngRateView}} %
                                        </div>
                                        <div class="engRate-text">
                                            Youtube Engagement Rate by Views
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- End of eng rate by views -->
                    <v-row align="left" justify="left" v-if="displayFields('industryBenchmark')">
                        <v-col cols="12" sm="12" md="12" lg="12" align="left">
                            <v-card
                                outlined
                                color="#000000"
                            >
                                <v-card-text>
                                    <div style="text-align:left;color:#3F3FFF;font-size:30px;">
                                        <v-layout wrap>
                                            <div style="padding-bottom:20px">
                                                Industry Benchmark for&nbsp;
                                            </div>
                                            <div>
                                                <span class="benchmark-fields" v-if="editBenchmark">
                                                    <v-text-field
                                                        class="edit-box"
                                                        v-model="campaignKPI.benchmarkTitle"
                                                        solo
                                                    ></v-text-field>
                                                </span>
                                                <span class="benchmark-fields" v-else>{{campaignKPI.benchmarkTitle}}</span>
                                            </div>
                                            <div>&nbsp;:&nbsp;</div>
                                            <div>
                                                <span class="benchmark-fields" v-if="editBenchmark">
                                                    <v-text-field
                                                        class="edit-box"
                                                        v-model="campaignKPI.benchmarkValue"
                                                        solo
                                                    ></v-text-field>
                                                </span>
                                                <span class="benchmark-fields" v-else>{{campaignKPI.benchmarkValue}}</span>
                                            </div>
                                            <div class="benchmark-edit">
                                                <v-btn
                                                @click.native.stop
                                                @click="saveBenchmark"
                                                color="success"
                                                dark
                                                v-if="editBenchmark && showRequiredActions()"
                                                >
                                                <v-icon>mdi-done</v-icon> Save
                                                </v-btn>
                                                <v-btn
                                                @click.native.stop
                                                @click="editBenchmarkAction"
                                                color="warning"
                                                small
                                                dark
                                                v-if="!editBenchmark && showRequiredActions()"
                                                >
                                                <v-icon small title="Edit Campaign Summary">edit</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-layout>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                </v-card-text>
            </v-card>
        </v-container>
        <table-cols-show-hide-modal
        v-model="colSettingsDialog"
        title="Overall"
        :items="tableColsItems"
        @updated="updatePerformanceAnalysisStatus"
        />
    </div>
</template>
<script>
/* eslint-disable */
import campaignAPIs from '../views/Campaign/campaignAPIs'
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import config from '@/config';
export default {
  name: 'rpt_campaign_per',
  components: {
    TableColsShowHideModal
  },
  props: ['campaignID', 'summary', 'campaign', 'campaignKPI', 'posts', 'reels', 'tikTokPosts', 'youtubePosts'],
  data () {
    return {
		editBenchmark: false,
        colSettingsDialog: false,
        tableColsItems: [],
        showHideFields: [
            {
                name: 'totalContents',
                label: 'Total Contents'
            },
            {
                name: 'totalOutreach',
                label: 'Total Audience Size'
            },
            {
                name: 'contents',
                label: 'Contents'
            },
            {
                name: 'outreachImpressions',
                label: 'Audience Size Impressions'
            },
            {
                name: 'outreach',
                label: 'Audience Size'
            },
            {
                name: 'interactions',
                label: 'Interactions'
            },
            // {
            //     name: 'totalEngRate',
            //     label: 'Total Engagement Rate'
            // },
            {
                name: 'postEngRate',
                label: 'Post Engagement Rate by Interactions'
            },
            {
                name: 'reelEngRate',
                label: 'Reel Engagement Rate by Interactions'
            },
            {
                name: 'tiktokEngRate',
                label: 'TikTok Engagement Rate by Interactions'
            },
            {
                name: 'youtubeEngRate',
                label: 'Youtube Engagement Rate by Interactions'
            },
            {
                name: 'postEngRateView',
                label: 'Post Engagement Rate by Views'
            },
            {
                name: 'reelEngRateView',
                label: 'Reel Engagement Rate by Views'
            },
            {
                name: 'tiktokEngRateView',
                label: 'TikTok Engagement Rate by Views'
            },
            {
                name: 'youtubeEngRateView',
                label: 'Youtube Engagement Rate by Views'
            },
            {
                name: 'industryBenchmark',
                label: 'Industry Benchmark'
            }
        ]
    }
  },
  computed: {
    totalEngagementRate() {
      let totalEng = 0;
      this.posts.map(item => {
        totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
      })
      const postEng = totalEng > 0 ? (totalEng / this.posts.length).toFixed(2) : 0
      // reels
      totalEng = 0
      this.reels.map(item => {
        totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
      })
      const reelEng = totalEng > 0 ? (totalEng / this.reels.length).toFixed(2) : 0
     //tiktok
      totalEng = 0
      this.tikTokPosts.map(item => {
        totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
      })
      const tikTokEng = totalEng > 0 ? (totalEng / this.tikTokPosts.length).toFixed(2) : 0
      // youtube
      totalEng = 0;
      this.youtubePosts.map(item => {
        totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
      })
      const youtubeEng = totalEng > 0 ? (totalEng / this.youtubePosts.length).toFixed(2) : 0
      return parseFloat(postEng) + parseFloat(reelEng) + parseFloat(tikTokEng) + parseFloat(youtubeEng)
    },
    totalAverageEngagementRate() {
      let totalAvgEng = 0;
      this.posts.map(item => {
        totalAvgEng += item.engagement_rate_sd ? item.engagement_rate_sd : 0
      })
      this.reels.map(item => {
        totalAvgEng += item.engagement_rate_sd ? item.engagement_rate_sd : 0
      })
      return ((totalAvgEng / (this.posts.length + this.reels.length))).toFixed(2)
    },
    postEngRate() {
        let totalEng = 0;
        this.posts.map(item => {
            totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
        })
        return ((totalEng / this.posts.length)).toFixed(2)
    },
    reelEngRate() {
        let totalEng = 0;
        this.reels.map(item => {
            totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
        })
        return ((totalEng / this.reels.length)).toFixed(2)
    },
    tiktokEngRate() {
        let totalEng = 0;
        this.tikTokPosts.map(item => {
            totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
        })
        return ((totalEng / this.tikTokPosts.length)).toFixed(2)
    },
    youtubeEngRate() {
        let totalEng = 0;
        this.youtubePosts.map(item => {
            totalEng += item.new_engagement_rate ? parseFloat(item.new_engagement_rate) : 0
        })
        return ((totalEng / this.youtubePosts.length)).toFixed(2)
    },
    postEngRateView() {
        let totalEng = 0;
        this.posts.map(item => {
            totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0
        })
        return ((totalEng / this.posts.length)).toFixed(2)
    },
    reelEngRateView() {
        let totalEng = 0;
        this.reels.map(item => {
            totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0
        })
        return ((totalEng / this.reels.length)).toFixed(2)
    },
    tiktokEngRateView() {
        let totalEng = 0;
        this.tikTokPosts.map(item => {
            totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0
        })
        return ((totalEng / this.tikTokPosts.length)).toFixed(2)
    },
    youtubeEngRateView() {
        let totalEng = 0;
        this.youtubePosts.map(item => {
            totalEng += item.new_engagement_rate_view ? parseFloat(item.new_engagement_rate_view) : 0
        })
        return ((totalEng / this.youtubePosts.length)).toFixed(2)
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    }
  },
  mounted() {
  },
  methods: {
    editBenchmarkAction() {
        if(this.showRequiredActions()) {
            this.editBenchmark = true
        }
    },
    saveBenchmark() {
        let benchmark = Object.assign({}, {
            title: this.campaignKPI.benchmarkTitle,
            value: this.campaignKPI.benchmarkValue
        })
        let formData = new FormData();
        formData.append('benchmark', JSON.stringify(benchmark));
        // Submit request to upload file
        campaignAPIs
        .updateCampaignBenchmark(this.campaignID, formData)
        .then(response => {
            this.editBenchmark = false
        })
        .catch(error => {
            // Request failed.
            console.log('error', error);
            this.$swal({
                text: error,
                type: 'error'
            });
        });
    },
    showRequiredActions: function() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false
      } else {
        return config.userRoles.CLIENT !== this.currentUserRole;
      }
    },
    async updatePerformanceAnalysisStatus(items) {
        let columns = this.campaign.performanceAnalysisStatus || {}
        items.map(item => {
            columns[item.key] = item.value
        })
        let data = [Object.assign({}, {
            id: this.campaign.id,
            performanceAnalysisStatus: columns
        })]
        await this.$store.dispatch('campaign/updateCampaignByIds', data)
        this.colSettingsDialog = false
    },
    displayFields(field) {
      if (this.campaign.performanceAnalysisStatus !== undefined) {
        if (this.campaign.performanceAnalysisStatus[field]) {
          return true
        }
      }
      return false
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (this.campaign.performanceAnalysisStatus) {
        tmpStatuses = Object.assign({}, this.campaign.performanceAnalysisStatus)
      } else {
        this.showHideFields.map(header => {
          tmpStatuses[header.name] = true
        })
      }
      for (const [key, value] of Object.entries(tmpStatuses)) {
        let header = this.showHideFields.find(item => item.name === key)
        if (header) {
          this.tableColsItems.push({
            title: header.label,
            key,
            value
          })
        }
      }
      this.colSettingsDialog = true
    }
  }
}
</script>
<style lang="css">
	.overall-section .edit-box {
		width:290px;
		margin-top: -10px!important;
	}
    .overall-section .benchmark-edit {
        margin-top: -5px;
        padding-left: 10px;
    }
    .overall-section .engRate-text {
        text-align:center;
        color: var(--ims-color-primary) !important;
        font-size:30px;
        line-height: 2rem;
    }
    .overall-section .overall-content,
    .overall-section .overall-content div {
        color: var(--ims-color-primary) !important;
    }
</style>




// WEBPACK FOOTER //
// performance.vue?071b625b